import * as styles from "./styles.module.scss"
import cx from "classnames"
import React, { useEffect, useState } from "react"

import { FlowQuestionId } from "types"
import SidebarItem from "../SidebarItem"

export interface SidebarProps {
  inProgress: boolean
  currentQuestionId: FlowQuestionId
}

const Sidebar: React.FC<SidebarProps> = ({ currentQuestionId, inProgress }) => {
  const [step, setStep] = useState(0)
  const numberOfItems = 6
  const animationSettings = {
    total: 9,
    loopStart: 4,
  }

  function incrementAnimationCount() {
    if (step === animationSettings.total - 1) {
      setStep(animationSettings.loopStart)
    } else {
      setStep((prevState) => {
        return prevState + 1
      })
    }
  }

  useEffect(() => {
    incrementAnimationCount()
  }, [currentQuestionId])

  return (
    <div className={styles.sidebar} data-sidebar-animation={step}>
      <div
        className={cx({
          [styles.content]: true,
          [styles.inProgress]: inProgress,
          [styles.end]: currentQuestionId === FlowQuestionId.End,
        })}
      >
        <div className={styles.header}>
          <h6 className={styles.eyebrow}>Building your recommendations</h6>
        </div>
        <div className={styles.mask}>
          <ul className={styles.list}>
            {Array.from(Array(numberOfItems).keys()).map((x) => (
              <li
                className={styles.item}
                key={`sidebar-item-${x}`}
                data-sidebar-item
              >
                <SidebarItem />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
